import { Component, OnDestroy, OnInit } from '@angular/core';
import { dasa } from 'src/classess/dasaClasses';
import { test } from 'src/classess/DasaAppUtil';
import { ActivatedRoute, Router } from '@angular/router';
import { commonService } from '../services/common.service';
import { StoreConfigurationsService } from '../services/store-configurations.service';
import Swal from 'sweetalert2';
import { StoreSettingsApi } from '../services/store-settings.service';

@Component({
  selector: 'app-choosestore',
  templateUrl: './choosestore.component.html',
  styleUrls: ['./choosestore.component.scss']
})
export class ChoosestoreComponent implements OnInit, OnDestroy {

  stores: dasa.Store[] = [];
  requestObject: dasa.RequestObject = new dasa.RequestObject();
  loggedInuser: any;
  FILE_STREAM_URL: any;

  constructor(
    private commonService_servive: commonService,
    private route: ActivatedRoute,
    private router: Router,
    private configurationService:StoreConfigurationsService,
    private storeSettingsApi: StoreSettingsApi
  ) { }

  async ngOnInit(): Promise<void> {
    document.body.classList.add('dasa-auth-page');
    this.FILE_STREAM_URL = dasa.Constant.FILE_STREAM_URL;
    await test.DasaAppUtil.loadFromSession();
    this.stores = dasa.Utility.stores;
    this.loggedInuser = dasa.Utility.loggedInUser;
  }

  ngOnDestroy(): void {
    document.body.classList.remove('dasa-auth-page');
  }

  /**
   * TODO: will implement later 
   * @param storeid 
   */
  openSelectedStore(storeid: any, lat: any, long: any) {
    dasa.Utility.showBusy();
    if (storeid * 1 > 0) {
      dasa.Utility.selectedStoreId = storeid;
      dasa.Utility.selectedBusinessId = dasa.Utility.businesses[0].id;
      // Companies are per-store. Carrying the previous store's company selection
      // over would scope the new store's dashboard to a company that doesn't
      // exist there (empty / wrong data), so reset to Combined on every switch.
      dasa.Utility.selectedCompanyId = -1;
      // hit server to get myStoreSetting
      this.requestObject.command = dasa.Constant.ACTION_TYPE_GET_MY_STORE_SETTING;
      this.requestObject.storeId = dasa.Utility.selectedStoreId;
      this.requestObject.businessId = dasa.Utility.selectedBusinessId;
      // console.log("getmystoresetting ::s" + JSON.stringify(this.requestObject));
      // this.commonService_servive.doAPICall(this.requestObject, environment.NEW_BACKEND_URL).subscribe(
      //   (res: any) => {
      //     dasa.Utility.users = res.myStoreSettings.users;
      //     dasa.Utility.brands = res.myStoreSettings.brands;
      //     dasa.Utility.categories = res.myStoreSettings.categories;
      //     dasa.Utility.storeItems = res.myStoreSettings.storeItems;
      //     dasa.Utility.storeSettings = res.myStoreSettings.storeSettings;
      //     // console.log(res);
      //     await test.DasaAppUtil.putInSession();
      //     // register for notification 
      //     this.requestObject.command = dasa.Constant.ACTION_TYPE_REGISTER_USER_NOTIFICATION;
      //     this.requestObject.storeId = dasa.Utility.selectedStoreId;
      //     this.requestObject.storeAdminId = dasa.Utility.loggedInUser.id;
      //     this.commonService_servive.doAPICall(this.requestObject, environment.NEW_BACKEND_URL).subscribe((res: any) => {
      //       // sessionStorage.setItem("sessionSocketId", JSON.stringify(dasa.Utility.socketId));
      //       dasa.Utility.socketId = res.socketId;
      //       await test.DasaAppUtil.putInSession();
      //       });
      //     // register for notification
      //     // this.router.navigate(['/admin/dashboard']);
      //     dasa.Utility.latitude = Number(lat);
      //     dasa.Utility.longitude = Number(long);
      //     await test.DasaAppUtil.putInSession();
      //     this.loadStoreSettings()
      //     // dasa.Utility.hideBusy();
      //     this.router.navigate(['/admin/new-reports']);
      //   });
      this.storeSettingsApi.getByStoreId(storeid).subscribe({
        next: async (s: dasa.StoreSettings) => {
          // Keep your existing shape (requestObject.storeSetting is used everywhere)
          try {
            this.requestObject.storeSetting = {
              ...s,
              // convert numeric scheduledOrders -> boolean for your form/select
              scheduledOrders: (s.scheduledOrders ?? 0) > 0 ? 1 : 0,
            } as any;
            s.timingJson;
            dasa.Utility.storeSettings = s;
            // console.log(res);
            await test.DasaAppUtil.putInSession();
            // Wait for the NEW store's configuration to load before landing on
            // the dashboard, otherwise the dashboard's first load runs against
            // the previous store's config (wrong/empty data until Apply).
            await this.loadStoreSettings();
          } catch (error) {
            console.log(error);
          }

          // dasa.Utility.hideBusy();
          // Land on the redesigned Analytics Dashboard after store pick.
          this.router.navigate(['/admin/dashboard']);
          // Timing
          // Disabled arrays & checkboxes
        },
        error: (err) => {

            Swal.fire({ text: 'Failed to fetch store settings.'+err, icon: 'error', timer: 2000 });
          
        }
      });
    }
  }
  shortstoreName(storeName: any) {
    if (storeName.length >= 75) {
      return `${storeName.substr(0, 75)}...`;
    }
    return storeName;
  }
  loadStoreSettings(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.configurationService.getStoreConfigurations(dasa.Utility.selectedStoreId).subscribe({
        next: async (res: any) => {
          const data = res?.data;
          // If no record or failed response -> show defaults right away
          if (res?.success || data) {
            dasa.Utility.storeConfigurations = data;
            await test.DasaAppUtil.putInSession();
          }
          resolve();
        },
        error: () => resolve(),
      });
    });
  }
}
